// Add a job scroll value set to 500px, used to display jobmail popup when user scrolls search in search view
// Jobmail will automatically open, if user scrolls search down to 500 pixels
export const JOBMAIL_POPUP_SCROLL = 500

// Set timeout for jobmail animation to 500ms
export const JOBMAIL_ANIMATION_TIMEOUT = 500

export const GENERIC_ERROR_MESSAGE = 'Es ist ein unbekannter Fehler aufgetreten.'
export const SUCCESSFULLY_ACTIVATED_MESSAGE = {
  title: 'Vielen Dank',
  text: 'Ihre Jobmail wurde erfolgreich aktiviert.'
}

export const JOBMAIL_FORM_CLOSED_TITLE = 'Passende Jobs per E-Mail erhalten'

export const JOBMAIL_FORM_OPEN_TITLE = 'Neueste Jobs per E-Mail'

export const JOBMAIL_FORM_TEXT = 'Aktivieren Sie Ihre persönliche Jobmail und wir informieren Sie per E-Mail kostenfrei über neue passende Jobs zu Ihrer Suchanfrage'

export const COMPANY_JOBMAIL_FORM_TITLE = 'Neue Stellenangebote per E-Mail erhalten'
